import React, { Component } from 'react'
import Axios from 'axios';
import LS_SERVICE from '../../../utils/localStorage';
import { Link } from 'react-router-dom'
import { Form, Select, Modal } from 'antd';
import PDFImg from '../../../assets/images/ic-pdf.png';
import {
  LOADER_RED,
  PATIENT_DISCHARGE_SUMMARY_LIST
} from '../../../utils/constant';
import moment from 'moment';
import qs from 'qs';

const { Option } = Select;

export default class PatientDischargeSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedEncounterData: props.selectedEncounterData,
      DischargeListData : null,
      DischargeTimelineData : null,
      loader: true,
      showRxModal: false,
      rxPdfPath: null,
    }
  }

  async componentDidMount() {
    Axios.defaults.headers.common["Authorization"] = LS_SERVICE.get("token");
    await this.getPatientCaseSheetData();
    
  }

  async getPatientCaseSheetData() {
    const { selectedEncounterData } = this.state;
    let PARAMS = {
      patient_Id: selectedEncounterData.registrationId,
      encounter_Id: selectedEncounterData.encounter_id,
      enterprise_Id: selectedEncounterData.enterpriseId,
      facility_Id: selectedEncounterData.facilityId,
    }
    await Axios.post(PATIENT_DISCHARGE_SUMMARY_LIST, qs.stringify(PARAMS))
    .then(async res => {
      let DischargeListData =  res.status ? res?.data?.data?.discharge_summary_data : null;
      let DischargeTimelineData =  res.status ? res?.data?.data?.timeline_data : null;
      await this.setState({
        DischargeListData: DischargeListData,
        DischargeTimelineData: DischargeTimelineData,
        loader: false
      });
    })
  }

  PatientDischargeListLoad() {
    try {
      const { DischargeTimelineData } = this.state;
      if ((!this.state.DischargeListData || this.state.DischargeListData.length === 0)) {
        let htmlData = (
          <tr>
            <td className="inner_table text-center" colSpan={4}>No Records Found.</td>
          </tr>
        )
        return htmlData;
      }
      const { DischargeListData } = this.state;
      let htmlData = (
        <tr id={DischargeListData.encounter_Id}>
          <td>{DischargeListData.form_name}</td>
          <td>{DischargeTimelineData[0].created_by_name}</td>
          <td>{DischargeTimelineData[0].action_type > 0 ? "Authorized" :"Saved"}</td>
          <td><a onClick={() => { this.setState({ rxPdfPath: DischargeListData.filepath, showRxModal: true }); }}><img src={PDFImg} alt="view" width={15} /></a></td>
        </tr>
      )
      return htmlData;
    } catch (err) {
      console.log('PatientDischargeListLoad: ', err);
    }
  }

  
  render() {
    const { loader } = this.state;
    return (
      <>
        { loader ? 
          <div className='row mt-3'>
            <div className="col-12  text-center mt-4">{LOADER_RED}
            </div>
          </div>
          :
          <div className='row mt-3'>
            <div className='col-12'>
              <table className='table table-bordered'>
                  <thead>
                      <tr>
                          <th width="" className='px-1 py-2' style={{verticalAlign:'top'}}>Form Name</th>
                          <th width="28%" className='px-1 py-2' style={{verticalAlign:'top'}}>Saved By</th>
                          <th width="18%" className='px-1 py-2' style={{verticalAlign:'top'}}>Status</th>
                          <th width="10%" className='px-1 py-2' style={{verticalAlign:'top'}}>File</th>
                      </tr>
                  </thead>
                  <tbody>
                    {this.PatientDischargeListLoad()}
                  </tbody>
              </table>
            </div>
          </div>
        }

        <Modal
          title="View Case Sheet"
          visible={this.state.showRxModal}
          footer={false}
          width={850}
          onCancel={() => { this.setState({ showRxModal: false, rxPdfPath: null }) }}
          style={{ top: 20 }}
        >
          <div className="row">
              <div className="col-12 my-3 text-center">
                  {this.state.rxPdfPath != null ? <iframe src={this.state.rxPdfPath} frameBorder="0" scrolling="no" style={{ overflow: 'hidden' }} width="100%" height="700">
                      {LOADER_RED}
                  </iframe> : null}
              </div>
          </div>
        </Modal>
      </>
    )
  }
}
